import { atom } from 'recoil';

export const withIsLoading = atom<boolean>({
  key: 'loading.isLoading',
  default: false
});
